import { b as angleInlineEnd, n as caretInlineEnd, p as angleDoubleInlineEnd, q as angleDoubleInlineStart } from './localIcons-B_pWoZ1u-Bxh9jPb6.js';

const angleDoubleRight = {
  ...angleDoubleInlineEnd};
const angleDoubleLeft = {
  ...angleDoubleInlineStart};
const angleRight = {
  ...angleInlineEnd,
  iconName: 'angle-right'
};
const caretRight = {
  ...caretInlineEnd,
  iconName: 'caret-right'
};

export { angleRight as a, angleDoubleRight as b, caretRight as c, angleDoubleLeft as d };
//# sourceMappingURL=classicIcons-Dl_q4l5f--kL9Y5b9.js.map
